import React from 'react';

import { JiraProductDiscoveryIcon, JiraProductDiscoveryLogo } from '@atlaskit/logo';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => (
	<LogoTable
		logo={<JiraProductDiscoveryLogo appearance="brand" />}
		icon={<JiraProductDiscoveryIcon appearance="brand" />}
	/>
);
